import { t } from '../../i18n/translate.js';
import { getErrorCode, getCommonErrorMessage } from '../getErrorUtils.js';

var getErrorMessage = function getErrorMessage() {
  var t$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t;
  return function (error) {
    var errorCode = getErrorCode(error || {});
    var _getCommonErrorMessag = getCommonErrorMessage(errorCode),
      title = _getCommonErrorMessag.title,
      description = _getCommonErrorMessag.description;
    var getLogTraceId = function getLogTraceId(e) {
      return e.graphQLErrors && e.graphQLErrors.length > 0 && e.graphQLErrors[0].data && e.graphQLErrors[0].data.logTraceId || null;
    };
    return {
      title: t$1(title),
      description: t$1(description),
      errorCode: errorCode,
      error: error,
      logTraceId: (getLogTraceId === null || getLogTraceId === void 0 ? void 0 : getLogTraceId(error)) || null
    };
  };
};

export { getErrorMessage };
